import { NetworkId } from '../global';
import { ApiResponseDto } from './api-response.dto';
import { AqiStandardV2Dto } from './aqi-standard.dto';
import { DistanceUnitSystem } from '../distance';
import { SelectedPollutantDto } from './selected-pollutant.dto';
import { Icon } from './icon.dto';

export enum DatasourceDetailsSection {
  HEALTH_RECOMMENDATIONS = 'HEALTH_RECOMMENDATIONS',
  EQUIPMENT = 'EQUIPMENT',
  TREND = 'TREND',
  LOCATION = 'LOCATION',
  CURRENT = 'CURRENT',
  DOWNLOAD = 'DOWNLOAD',
  ACTION_RECOMMENDATIONS = 'ACTION_RECOMMENDATIONS',
}

export class NetworkV2Dto {
  networkId: NetworkId;
  name: string;
  logoUrl: string;
  networkUrl: string | null;
  datasourceDetailsSections: DatasourceDetailsSection[];
  visible: boolean;
  selectedPollutants: SelectedPollutantDto[];
  distanceUnitSystem: DistanceUnitSystem;
  isNotificationEnabled: boolean;
  defaultOpenSiteRadiusInKm: number;
  defaultOpenSiteIcon: Icon;
}

export class NetworkSummaryDto {
  networkId: NetworkId;
  name: string;
  logoUrl: string;
  visible: boolean;
}

export class GetNetworksResponseDto extends ApiResponseDto<{
  networks: NetworkSummaryDto[];
}> {
  declare data: {
    networks: NetworkSummaryDto[];
  };
  declare metadata: { timestamp: Date };
}

export class GetSingleNetworkV2ResponseDto extends ApiResponseDto<{
  network: NetworkV2Dto;
  aqiStandards: AqiStandardV2Dto[];
}> {
  declare data: {
    network: NetworkV2Dto;
    aqiStandards: AqiStandardV2Dto[];
  };
  declare metadata: { timestamp: Date };
}
